import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function getHolidaysList() {
    return axios.get(`${url}/holiday/list`).then(response => {
        return {
            holidaysList: response.data,
        };
    }).catch(err => {
        return {
            holidaysList: err,
        };
    });
}

function getHolidaysDateList(id) {
    return axios.get(`${url}/holiday/`+ id).then(response => {
        return {
            holidaysDateList: response.data,
        };
    });
}

function createNewHolidays(payload) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/holiday/create`, payload, options).then(response => {
        return {
            createNewHolidays: response.data
        };
    });
}

function deleteHoliday(payload) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/holiday/delete/` + payload, options).then(response => {
        return {
            deletedHoliday: response.data
        };
    });
}
function getByDate(payload) {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/holiday/get-by-date`, payload, options).then(response => {
        return {
            holidaysByDate: response.data
        };
    });
}

export default {
    getHolidaysList,
    getHolidaysDateList,
    createNewHolidays,
    deleteHoliday,
    getByDate
};